var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackfill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.563 1.25h5m0 0v5m0-5l-17 17m17-4v5m0 0h-5m5 0l-6-6m-11-11l5 5",
    stroke: "#9211E1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.563 1.25h5m0 0v5m0-5l-17 17m17-4v5m0 0h-5m5 0l-6-6m-11-11l5 5",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy41NjI1IDEuMjVIMTguNTYyNU0xOC41NjI1IDEuMjVWNi4yNU0xOC41NjI1IDEuMjVMMS41NjI1IDE4LjI1TTE4LjU2MjUgMTQuMjVWMTkuMjVNMTguNTYyNSAxOS4yNUgxMy41NjI1TTE4LjU2MjUgMTkuMjVMMTIuNTYyNSAxMy4yNU0xLjU2MjUgMi4yNUw2LjU2MjUgNy4yNSIgc3Ryb2tlPSIjOTIxMUUxIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy41NjI1IDEuMjVIMTguNTYyNU0xOC41NjI1IDEuMjVWNi4yNU0xOC41NjI1IDEuMjVMMS41NjI1IDE4LjI1TTE4LjU2MjUgMTQuMjVWMTkuMjVNMTguNTYyNSAxOS4yNUgxMy41NjI1TTE4LjU2MjUgMTkuMjVMMTIuNTYyNSAxMy4yNU0xLjU2MjUgMi4yNUw2LjU2MjUgNy4yNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgBackfill as ReactComponent };